import { isInViewport } from './dom';

export function isOutbrainWidgetInViewport(selector) {
  return isInViewport(document.querySelector(selector));
}

export function detectOutbrainWidgetInViewport(selector, callback) {
  const outbrainWidget = document.querySelector(selector);
  if (!outbrainWidget) {
    return;
  }

  function observerCallback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        callback();
      }
    });
  }

  const observer = new IntersectionObserver(observerCallback);
  observer.observe(outbrainWidget);
}
